import React from 'react'
import { Modal as AntModal } from 'antd'

const Modal = ({ 
    title, 
    toggle, 
    w = 512,
    visible, 
    children, 
    style = {}, 
    className = '',
    closable = true, 
    centered = true ,
    maskClosable = true,
}) => {
    return (
        <AntModal 
            width={ w } 
            footer={ null }
            open={ visible } 
            onCancel={ toggle }
            style={{
                top: 25,
                ...style
            }} 
            closable={ closable } 
            centered={ centered }
            className={ className }
            maskClosable={ maskClosable }>
            <p className="font-extrabold text-3xl -mt-4 mb-2">{ title }</p>
            { children }
        </AntModal>
        // <div id="modal" style={ modalStyle } className={ `${ visible ? 'scale-100' : 'scale-0' } overflow-hidden overflow-y-scroll fixed z-30 ${bottom} top-0 left-0 w-screen h-screen flex ${align} justify-center transform transition-transform duration-300` }>
        //     {/* Modal content */}
        //     <span className={ `z-0 overflow-hidden absolute w-full h-full bg-gray-700 bg-opacity-50 ${maskClasses}` } onClick={ closable ? maskClosable ? toggle : null : null } />
        //     <div className={ `z-10 bg-white ${w} ${h} p-6 ${top}` }>
        //         <div className="sm:flex sm:justify-between sm:items-center mb-2">
        //             <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
        //                 {
        //                     closable ? 
        //                         <button onClick={ toggle } id="closebutton" type="button" className="focus:outline-none">
        //                             {/* Hero icon - close button */}
        //                             <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        //                                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
        //                             </svg>
        //                         </button>
        //                     : null
        //                 }
        //             </div>
        //         </div>
        //         { children }
        //     </div>
        // </div>
    )
}

export default Modal